import * as React from "react";
import { cn } from "./utils";

interface GlitchButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  text: string;
  /** Renders the dark "current page" pill from the design, without a hover. */
  active?: boolean;
}

export const GlitchButton = React.forwardRef<HTMLDivElement, GlitchButtonProps>(
  ({ className, text, active = false, onClick, ...props }, ref) => {
    return (
      <div
        ref={ref}
        onClick={onClick}
        className="relative inline-block group cursor-pointer select-none outline-none"
        {...props}
      >
        {/* Background Layers */}
        {/* Red (Bottom) - Static base */}
        <div className="absolute inset-0 bg-[#f42536] rounded-full translate-x-0 translate-y-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

        {/* Green - Moves Down Right */}
        <div className="absolute inset-0 bg-[#01e12d] rounded-full transition-all duration-300 group-hover:translate-x-[3px] group-hover:translate-y-[4px] opacity-0 group-hover:opacity-100" />

        {/* Blue - Moves Right */}
        <div className="absolute inset-0 bg-[#256af4] rounded-full transition-all duration-300 group-hover:translate-x-[4px] group-hover:translate-y-[0px] opacity-0 group-hover:opacity-100" />

        {/* Main Container (Black) - Moves Diagonal */}
        <div className={cn(
          "relative transition-all duration-300 rounded-full border border-[#141414] flex items-center justify-center group-hover:translate-x-[2px] group-hover:translate-y-[2px]",
          active ? "bg-[#141414]" : "bg-white group-hover:bg-[#141414]",
          "px-[24px] py-[12px]",
          className
        )}>
            {/* Main Text */}
            <span className={cn(
              "relative z-10 transition-colors duration-300 whitespace-nowrap font-inherit",
              active ? "text-white" : "text-[#141414] group-hover:text-white"
            )}>
                {text}
            </span>
        </div>
      </div>
    );
  }
);
GlitchButton.displayName = "GlitchButton";
